import React from 'react';
import { Modal, Button, Select, message } from 'antd';
import { translate } from 'react-i18next';
const Option = Select.Option;

class ModalClass extends React.Component {

  state = {
    className: '',
    grade: '',
    gradeNumber: '',
    subject: '',
    subjectCategory: '',
    teacher: [],
    students: [],
    subjectList: []
  }

  saveModal = () => {
    if (
      this.state.className == '' ||
      this.state.subject == '' ||
      this.state.className.length == 0
    ) {
      message.warning('All fields are mandatory, except grade and teacher!');
    } else {
      let data = this.state
      if (this.props.data && this.props.data.classId) {
        this.props.save(data, this.props.mode, this.props.data.classId)
      } else {
        this.props.save(data, this.props.mode)
      }
      this.setState({
        className: '',
        grade: '',
        gradeNumber: '',
        subject: '',
        teacher: [],
        students: null
      })
    }
  }

  cancel = () => {
    this.setState({
      className: '',
      grade: '',
      gradeNumber: '',
      subject: '',
      teacher: [],
      students: null
    })
    this.props.cancel()
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.data !== prevProps.data && this.props.mode == 'edit') {
      let data = this.props.data
      let grade = data.grade.split(' ')
      let subjectCategory = this.props.subjects && this.props.subjects[data.subject_id] && this.props.subjects[data.subject_id].category
      this.setState({
        className: data.className,
        grade: grade[0],
        gradeNumber: grade[1],
        subject: data.subject_id,
        subjectCategory: subjectCategory,
        teacher: data.teacher_id,
        students: data.student_ids
      })
    }
  }

  render() {

    const t = this.props.t

    let subjects;
    if (this.props.subjects && this.state.subjectCategory) {
      subjects = Object.entries(this.props.subjects)
        .filter(subject =>
          subject[1].category
          &&
          subject[1].category == this.state.subjectCategory
        )
    }

    return (
      <div>
        <Modal
          className="edituser"
          visible={this.props.open}
          onOk={this.saveModal}
          onCancel={this.cancel}
          okText={t('Ok')}
          cancelText={t('Cancel')}
        >
          <h3>{t('Class name')}</h3>
          <input style={{ paddingLeft: 10 }} type="text" value={this.state.className} onChange={(e) => this.setState({ className: e.target.value })} />
          <h3>{t('Grade')}</h3>
          <div style={{ display: 'inline-block' }}>
            <Select value={this.state.grade} style={{ width: 120, float: 'left' }} onChange={(value) => this.setState({ grade: value })}>
              <Option value="PYP">{t('PYP')}</Option>
              <Option value="MYP">{t('MYP')}</Option>
              <Option value="DP">{t('DP')}</Option>
              <Option value="Grade">{t('Grade')}</Option>
              <Option value="None">{t('Unspecified')}</Option>
            </Select>
            <input style={{ paddingLeft: 10 }} style={{ width: 120, paddingLeft: 10, border: '1px solid #d9d9d9', height: 33, borderRadius: '4px', marginLeft: 20, float: 'left' }} type="number" value={this.state.gradeNumber} onChange={(e) => this.setState({ gradeNumber: e.target.value })} />
          </div>
          <h3>{t('Teacher')}</h3>
          <Select value={this.state.teacher} style={{ width: '100%' }} mode="multiple" onChange={(value) => this.setState({ teacher: value })}>
            {this.props.teachers && this.props.teachers.map(teacher => (
              <Option value={teacher[0]}>{teacher[1].profile.name + ' ' + teacher[1].profile.last_name}</Option>
            ))}
          </Select>
          <h3 style={{ marginTop: 20 }}>{t('Subject Category')}</h3>
          <Select value={this.state.subjectCategory} style={{ width: '100%' }} onChange={(value) => this.setState({ subjectCategory: value })}>
            {this.props.subject_categories && Object.entries(this.props.subject_categories).map(cat => (
              <Option value={cat[0]}>{t(cat[1].name)}</Option>
            ))}
          </Select>
          <h3 style={{ marginTop: 20 }}>{t('Subject')}</h3>
          <Select value={this.state.subject} style={{ width: '100%' }} onChange={(value) => this.setState({ subject: value })}>
            {subjects && subjects.map(subject => (
              <Option value={subject[0]}>{t(subject[1].name)}</Option>
            ))}
          </Select>
          <h3>{t('Students')}</h3>
          <Select optionFilterProp='children' value={this.state.students} style={{ width: '100%' }} mode="multiple" onChange={(value) => this.setState({ students: value })}>
            {this.props.students && this.props.students.map(student => (
              <Option value={student[0]}>{student[1].profile.name + ' ' + student[1].profile.last_name}</Option>
            ))}
          </Select>
        </Modal>
      </div>
    )
  }
}
const dateFormat = 'DD/MM/YYYY';

export default ModalClass;

const styles = {
  input: {}
}



// WEBPACK FOOTER //
// ./src/components/ModalClass/index.jsx